<template lang="pug">
#thank-you.step-component
  h2 Thank you for completing the kit! Please drop the box off at your local {{ dropLocation }} by <span class="text-color">{{ dropOffText }}</span>.
  p If you do not mail your kit back within 24 hours the blood sample(s) may be voided. Your results will be ready in approximately 4 days. We'll be in touch as soon as they're ready to view.

  button.button.action-btn(@click="routeToUPS") Find Local UPS
  button(v-if="this.$route.meta.webViewContainer", @click="end") Return to the {{ this.$route.meta.webViewContainer }}
</template>

<script>
import CacheApi from '@/utils/cache-api'
import AmplitudeAPI from '@/utils/amplitude'
import MixpanelAPI from '@/utils/mixpanel'
import Vue from 'vue'

export default {
  props: {
    dropLocation: {
      type: String,
      required: true,
    },
    checkpointPosition: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      todaysDate: new Date(),
    }
  },

  mounted() {
    this.cleanupLocalStorage()
    this.cleanupCache()
    if (this.dropLocation == 'UPS') {
      this.$store.dispatch('user/completedKit')
    }
  },

  computed: {
    dropOffText() {
      if (localStorage.getItem('displayWarning') == 'false') {
        return 'by the end of the day'
      }
      var text
      switch (this.todaysDate.getDay()) {
        case 0:
          text = 'tomorrow morning'
          break
        case 5:
        case 6:
          text = '1 PM'
          break
        default:
          text = 'end of the day'
          break
      }
      return text
    },
  },

  watch: {},

  methods: {
    cleanupCache,
    routeToUPS,
    cleanupLocalStorage,
    end,
  },
  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
function routeToUPS() {
  window.location.href = 'https://www.ups.com/dropoff/'
}

function cleanupCache() {
  const eventTitle = 'KitCompleted'
  const eventProperties = {
    kit_type: this.$store.getters['user/getKitType'],
    medplum_id: this.$store.getters['user/getMedplumOrderId'],
    barcode: this.$store.getters['user/getBarcodeId'],
    sku: this.$store.getters['user/getSku'],
    customer: this.$store.getters['user/getConfigKeys']
      ? this.$store.getters['user/getConfigKeys'].carrier
      : null,
    end_date: new Date().toISOString(),
    source: this.$route.query.src,
  }

  AmplitudeAPI.logEvent(eventTitle, {
    ...eventProperties,
    linked_amplitude_id: this.$route.query.q,
  })

  MixpanelAPI.track(eventTitle, {
    ...eventProperties,
    application: 'Collection App',
  })

  Vue.axios.post('/app-checkpoint', {
    orderId: this.$store.getters['user/getMedplumOrderId'],
    checkpointPosition: this.checkpointPosition,
  })
  this.cacheApi = new CacheApi()
  this.cacheApi.clearVideoCache()
}

function cleanupLocalStorage() {
  localStorage.removeItem('currentSection')
  localStorage.removeItem('currentStep')
}

function end() {
  ReactNativeWebView.postMessage('user_ended')
}
</script>
